import { commonMessage } from '@locales/intl';
import { notification } from 'antd';

const showSucsessMessage = (content, translate) => {
    notification.success({
        message: translate?.formatMessage(commonMessage.notificationSuccess) || 'Success',
        description: content,
    });
};

const showErrorMessage = (content, translate) => {
    notification.error({
        message: translate?.formatMessage(commonMessage.notificationError) || 'Error',
        description: content,
    });
};

const showWarningMessage = (content, translate) => {
    notification.warning({
        message: translate?.t(`${translate.ns}:error`, 'Error Message') || 'Warning',
        description: content,
    });
};

export { showErrorMessage, showSucsessMessage, showWarningMessage };
